// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetSurveyResponse

export type WidgetSurveyApiResponse = {
	bookingId: string;
	isAnswered: boolean;
	alreadySubmitted: boolean;
	rating: number | null;
	comment: string | null;
	googleReviewsUrl: string | null;
};

export type WidgetSurvey = {
	bookingId: string;
	isAnswered: boolean;
	alreadySubmitted: boolean;
	rating: number | null;
	comment: string | null;
	googleReviewsUrl: string | null;
};

export function hydrateWidgetSurvey(data: WidgetSurveyApiResponse): WidgetSurvey {
	return { ...data };
}